import React, { useContext, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./City_Break.css";

import Common_Title from "../../../common_component/common_title/Common_Title";
import CommonTourCard from "../../../common_component/common_tour_card/Common_Tour_Card";
import { Context } from "../../../../utils/context";
import { useNavigate, useParams } from "react-router-dom";

function CityBreak() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [selectedCity, setSelectedCity] = useState(null);
  const [cities, setCities] = useState([]);
  const [packages, setPackages] = useState([]);

  const { getData } = useContext(Context);

  // Get all cities
  const getCities = async () => {
    const response = await getData("/master/holiday/");
    setCities(response?.data || []);
  };

  // Get packages
  const getPackagesByHoliday = async (holidayId) => {
    const response = await getData(`/master/packagebyholiday/${holidayId}/`);
    setPackages(response?.data || []);
  };

  useEffect(() => {
    getCities();
  }, []);

  // 🔹 Select city based on URL id
  useEffect(() => {
    if (cities.length > 0) {
      let city = cities.find((c) => String(c.id) === String(id));

      // If no id in URL → select first city
      if (!city) {
        city = cities[0];
        navigate(`/home/holidays/city-break/${city.id}`, { replace: true });
      }

      setSelectedCity(city);
      getPackagesByHoliday(city.id);
    }
  }, [cities, id]);

  // Click city
  const handleCityClick = (city) => {
    if (city.id !== Number(id)) {
      navigate(`/home/holidays/city-break/${city.id}`);
    }
  };

  return (
    <section className="argentina_section city_break">
      <div className="container">
        <Swiper
          modules={[Navigation]}
          spaceBetween={20}
          navigation
          breakpoints={{
            320: { slidesPerView: 3 },
            480: { slidesPerView: 4 },
            768: { slidesPerView: 7 },
            1024: { slidesPerView: 10 },
          }}
          className="city-swiper"
        >
          {cities?.map((item) => (
            <SwiperSlide key={item.id}>
              <div
                className={`city-item ${
                  Number(id) === item.id ? "selected" : ""
                }`}
                onClick={() => handleCityClick(item)}
              >
                <div className="city-card">
                  <div className="city-img">
                    <img src={item?.image} alt={item.name} />
                  </div>
                </div>
                <p className="city-label">{item.name}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="europe">
        <div className="container">
          <div className="destination_title">
            <Common_Title title={selectedCity?.name || "Packages"} />
          </div>

          <div className="row">
            {packages.length > 0 ? (
              packages.map((tour) => (
                <div className="col-lg-6 col-md-6 mb-4" key={tour.id}>
                  <CommonTourCard
                    title={tour?.title}
                    img={tour?.images?.[0]?.image}
                    location={tour?.location?.name}
                    duration={tour?.duration}
                    places={tour?.places_covered}
                    activity={tour?.activities_count}
                    data={tour}
                  />
                </div>
              ))
            ) : (
              <p>No packages found</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default CityBreak;
